import AITextCompletion from './ai_text_completion';

export default AITextCompletion;
